import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';

export interface OverlayAction {
    label: string;
    variant?: 'primary' | 'secondary' | 'warning' | 'danger';
    onClick: () => void;
    disabled?: boolean;
}

export interface OverlayProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    actions?: OverlayAction[];
    className?: string;
}

// Comptador d'overlays oberts: amb modals apilats (p. ex. l'editor obre
// l'analitzador de text), només restaurem el scroll del body quan es tanca
// l'últim. Si no, tancar-ne un de superior reactivaria el scroll de fons mentre
// encara n'hi ha un d'obert.
let openOverlayCount = 0;

export const Overlay: React.FC<OverlayProps> = ({ title, onClose, children, actions, className }) => {
    useEffect(() => {
        // Block body scroll while any overlay is mounted
        openOverlayCount++;
        document.body.style.overflow = 'hidden';

        return () => {
            openOverlayCount = Math.max(0, openOverlayCount - 1);
            if (openOverlayCount === 0) {
                document.body.style.overflow = '';
            }
        };
    }, []);

    return (
        <div className="overlay">
            <div className="inner">
                <div className={`overlay-content ${className || ''}`}>
                    <div className="overlay-header">
                        <h2>{title}</h2>
                        <button className="close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="overlay-body">
                        {children}
                    </div>

                    {actions && actions.length > 0 && (
                        <div className="overlay-footer">
                            {actions.map((action, index) => (
                                <Button
                                    key={index}
                                    variant={action.variant || 'primary'}
                                    onClick={action.onClick}
                                    disabled={action.disabled || false}
                                >
                                    {action.label}
                                </Button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
